module.exports = __webpack_public_path__ + "static/media/Materials and draft resolutions.1332cbb5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Materials and draft resolutions.pdf
// module id = 145
// module chunks = 0